import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {CustomerService} from '../services/customer.service';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/of';


@Injectable()
export class CheckoutParamsGuard implements CanActivate {
  constructor(private router: Router,
              private customerService: CustomerService) {
  }

  private isBoolean(string) {
    switch (string) {
      case 'true':
        return true;
      case 'false':
        return true;
      default:
        return false;
    }
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
    const queryParams = route.queryParams;
    if (
      'total_value' in queryParams &&
      'description' in queryParams &&
      'api_key' in queryParams &&
      'verify' in queryParams &&
      'signature' in queryParams
    ) {
      const price = Number.parseFloat(queryParams.total_value);
      if (queryParams.description.length > 1 &&
        queryParams.signature.length > 1 &&
        isFinite(queryParams.total_value) &&
        price >= 10000 &&
        price % 1 === 0 &&
        this.isBoolean(queryParams.verify)) {
        if ('shipping_price' in queryParams) {
          const shipping_price = Number.parseFloat(queryParams.shipping_price);
          if (isFinite(queryParams.shipping_price) &&
            shipping_price % 1 === 0) {
          } else {
            this.router.navigate(['404']);
            return false;
          }
        }
        if ('minutes' in queryParams) {
          if (isFinite(queryParams.minutes)) {
          } else {
            this.router.navigate(['404']);
            return false;
          }
        }

        return this.customerService.checkApiKeyCustomer(
          queryParams['api_key'],
          queryParams['total_value'],
          queryParams['description'],
          queryParams['verify'],
          queryParams['shipping_price'],
          queryParams['minutes'],
          queryParams['signature']
        ).map((res: any) => {
          return true;
        }).catch(() => {
          this.router.navigate(['404']);
          return Observable.of(false);
        });
      } else {
        this.router.navigate(['404']);
        return false;
      }
    } else {
      this.router.navigate(['404']);
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/guards/checkout-params.guard.ts